import { render, staticRenderFns } from "./zscqcsDetail.vue?vue&type=template&id=3888b06f&scoped=true"
import script from "./zscqcsDetail.vue?vue&type=script&lang=js"
export * from "./zscqcsDetail.vue?vue&type=script&lang=js"
import style0 from "./zscqcsDetail.vue?vue&type=style&index=0&id=3888b06f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888b06f",
  null
  
)

export default component.exports